export default "__VITE_ASSET__CRRLzTL9__"